/**
 * @file date
 * @author feibinyang
 */

/**
 * 解析时间格式
 *
 * @param {Date|string|number} date 日期字符串
 * @return {Date}
 */
export function parseDate(date) {
    if (typeof date === 'number') {
        return new Date(date);
    }
    else if (date instanceof Date) {
        return date;
    }
    date = String(date);
    let matches = date.match(/^(\d{2,4})[^\d]?(\d{2})[^\d]?(\d{2})[^\d]?(\d{2})?[^\d]?(\d{2})?[^\d]?(\d{2})?/);
    if (!matches) {
        return new Date(date);
    }
    // 月份 -1
    matches[2] = matches[2] - 1;
    matches = matches.slice(1, 8).map(value => value || 0);
    return new Date(...matches);
}
